import { Icon, IconProps } from "../";

export const CommentLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22132 20.5L6.32927 18.392L5.45233 17.3397C4.17377 15.8054 3.5 13.9441 3.5 12C3.5 7.32843 7.32843 3.5 12 3.5C16.6716 3.5 20.5 7.32843 20.5 12C20.5 16.6716 16.6716 20.5 12 20.5H4.22132ZM12 2C6.5 2 2 6.5 2 12C2 14.3 2.8 16.5 4.3 18.3L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.5 21.9 2.7 22 3 22H12C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM7 12C7 12.6 7.4 13 8 13C8.6 13 9 12.6 9 12C9 11.4 8.6 11 8 11C7.4 11 7 11.4 7 12ZM12 13C11.4 13 11 12.6 11 12C11 11.4 11.4 11 12 11C12.6 11 13 11.4 13 12C13 12.6 12.6 13 12 13ZM15 12C15 12.6 15.4 13 16 13C16.6 13 17 12.6 17 12C17 11.4 16.6 11 16 11C15.4 11 15 11.4 15 12Z"
      />
    </Icon>
  );
};
